module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./GlanceOverView.js"));
	}, "GlanceOverView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GlanceOverView!./src/pages/Shop/Member/Personal/GlanceOver/GlanceOverView.js
// module id = 1913
// module chunks = 367